module.exports = __webpack_public_path__ + "img/female-adult-figure.23679ba1.svg";